import Vue from 'vue/dist/vue.esm';

// We do use rails ujs for removing from cart
import Rails from "@rails/ujs";
Rails.start();

// Axios defaults
import axiosSetup from '../shared/api_key_axios_setup';
import validate from './config/validate.js';

import './styles/tailwind.css';

import { initSentry } from '../shared/sentry_config';

// Initialize Sentry
initSentry(Vue);


import Product from './product.vue'
import Cart from './cart.vue';
import Checkout from './checkout.vue';
import TeamApiService from '../shared/team_api_service';
import VueForceNextTick from 'vue-force-next-tick';
Vue.use(VueForceNextTick);

document.addEventListener('DOMContentLoaded', () => {
  // Setup axios
  axiosSetup();
  // Setup the axios and vee-validate rules
  validate();

  // Event bus for the cart
  const notificationManager = new Vue();
  Object.defineProperties(Vue.prototype, {
    $notificationManager: {
      get() {
        return notificationManager;
      },
    },
  });

  const api = new TeamApiService();
  Object.defineProperties(Vue.prototype, {
    $apiService: {
      get() {
        return api;
      },
    },
  });

  const app = new Vue({
    el: '#onlinestore-vue-wrapper',
    components: {
      Cart,
      Checkout,
      Product
    },
  });
});
